import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const DropdownNavItem = (props) => {
  const {
    navUrl,
    navText,
    notReactLink,
    handleMouseClick,
    guestRequestCount,
    receivesNotifications
  } = props;
  return (
    <li
      className={
        guestRequestCount === 0 && receivesNotifications ? 'hide-nav-item' : null
      }
    >
      {notReactLink ? (
        <a href={navUrl} onClick={handleMouseClick}>
          {navText}
        </a>
      ) : (
        <Link to={navUrl} onClick={handleMouseClick}>
          {navText}
          {receivesNotifications && guestRequestCount !== 0 && (
            <span className="drop-down-badge badge">{guestRequestCount}</span>
          )}
        </Link>
      )}
    </li>
  );
};

DropdownNavItem.defaultProps = {
  notReactLink: false
};

DropdownNavItem.propTypes = {
  handleMouseClick: PropTypes.func.isRequired,
  navUrl: PropTypes.string.isRequired,
  navText: PropTypes.string.isRequired,
  notReactLink: PropTypes.bool,
  guestRequestCount: PropTypes.number,
  receivesNotifications: PropTypes.bool
};

export default DropdownNavItem;



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNav/DropdownNavItem.jsx